import React from 'react';
import StylePropType from 'react-style-proptype';
import Styles from './styles';

const Hr = props => <div style={{ ...Styles.wrapper, ...props.style }} />;

Hr.propTypes = {
  style: StylePropType,
};

Hr.defaultProps = {
  style: {},
};

export default Hr;



// WEBPACK FOOTER //
// ./src/components/UIKit/Hr/index.js